import { useMutation, useQueryClient } from '@tanstack/react-query'

import { USER_QUERY_KEYS } from '../api/endpoints'
import type { UserApi } from '../api/userApi'
import type { UpdateMyProfilePayload } from '../types/user.types'

export interface UseUpdateMyProfileOptions {
  api: UserApi
  userId: number
}

export const useUpdateMyProfile = ({
  api,
  userId,
}: UseUpdateMyProfileOptions) => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, UpdateMyProfilePayload>({
    mutationFn: async (payload) => {
      const response = await api.updateMyProfile(userId, payload)
      if (!response.ok) {
        throw new Error('Failed to update profile')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: USER_QUERY_KEYS.myProfile(userId),
      })
    },
  })
}
